import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Lookup,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useState } from "react";
import { billingTiming } from "../../data";

export default function BillingTimingGrid(props) {
  const { setContrNo } = props;

  const [dataSource, setDataSource] = useState(
    new CustomStore({
      key: "contrNo",
      load: async () => {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/billingTiming`
        );

        return result.data;
      },
      insert: async (values) => {},
      update: async (key, values) => {
        await axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/billingTiming/${key}`,
          values
        );
      },
      remove: async (key) => {},
    })
  );

  const onSelectionChanged = ({ selectedRowsData }) => {
    setContrNo(selectedRowsData[0].contrNo);
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#B4C6E7";

      switch (e.column.dataField) {
        case "AOSBillingTiming":
        case "PTCBillingTiming":
          e.cellElement.style.backgroundColor = "#FFE699";
          break;
      }
    }
  };

  return (
    <DataGrid
      dataSource={dataSource}
      keyExpr={"contrNo"}
      showBorders={true}
      allowColumnReordering={true}
      allowColumnResizing={true}
      rowAlternationEnabled={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"100%"}
      style={{
        maxHeight: "calc(100vh - 145px)",
      }}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      onSelectionChanged={onSelectionChanged}
      onCellPrepared={onCellPrepared}
    >
      <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <LoadPanel enabled={true} />
      <HeaderFilter visible={true} />
      {/* <FilterRow visible={true} applyFilter={"auto"} /> */}
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <Selection mode={"single"} />

      <Editing
        mode={"batch"}
        allowAdding={false}
        allowUpdating={true}
        allowDeleting={false}
        selectTextOnEditStart={true}
        startEditAction={"dblClick"}
      />

      <Column
        dataField={"contrNo"}
        caption={"Contract No."}
        width={140}
        allowEditing={false}
      />
      <Column
        dataField={"sprName"}
        caption={"Company Name"}
        width={210}
        allowEditing={false}
      />
      <Column
        dataField={"projName"}
        caption={"Project Name"}
        showEditorAlways={true}
      />
      <Column
        dataField={"protocolNo"}
        caption={"Protocol No."}
        width={220}
        showEditorAlways={true}
      />
      <Column
        dataField={"AOSBillingTiming"}
        caption={"AOS"}
        width={100}
        showEditorAlways={true}
      >
        <Lookup
          dataSource={billingTiming}
          valueExpr={"id"}
          displayExpr={"name"}
        />
      </Column>
      <Column
        dataField={"PTCBillingTiming"}
        caption={"PTC"}
        width={100}
        showEditorAlways={true}
      >
        <Lookup
          dataSource={billingTiming}
          valueExpr={"id"}
          displayExpr={"name"}
        />
      </Column>
    </DataGrid>
  );
}
